import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import SliderControls from '../mixins/SliderControls';
import Gallery2 from '../components/gallery2/Gallery2';
import Quote from '../components/quote/Quote';
import GFade from '../components/gfade/GFade';
// import anime from 'animejs/lib/anime.es.js';
// @ts-ignore

@Component({
  mixins: [SliderControls],
  components: {
    Gallery2,
    Quote,
    GFade
  }
})
export default class VMCases extends Vue {

}
